import { Link, useLocation } from 'react-router-dom'
import { ThemeToggle } from '../theme/ThemeToggle'

interface ClientHeaderProps {
  cartCount?: number
  onCartClick?: () => void
}

export function ClientHeader({ cartCount = 0, onCartClick }: ClientHeaderProps) {
  const location = useLocation()
  const isHome = location.pathname === '/'
  const isOrderPage = location.pathname === '/order'

  return (
    <header className="client-header" role="banner">
      <div className="container">
        <div className="client-header-inner">
          <Link to="/" className="client-header-brand" aria-label="CV Berkah Nusa Sejati - Beranda">
            <svg className="client-header-logo" viewBox="0 0 32 32" fill="none" aria-hidden="true">
              <rect width="32" height="32" rx="8" fill="currentColor" />
              <path d="M8 12h16M8 16h12M8 20h8" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <span className="client-header-title">CV Berkah Nusa Sejati</span>
          </Link>

          <nav className="client-header-nav" aria-label="Navigasi pelanggan">
            <Link
              to="/"
              className={`client-header-link ${isHome ? 'active' : ''}`}
              aria-current={isHome ? 'page' : undefined}
            >
              Beranda
            </Link>
            <Link
              to="/order"
              className={`client-header-link ${isOrderPage ? 'active' : ''}`}
              aria-current={isOrderPage ? 'page' : undefined}
            >
              Belanja
            </Link>
          </nav>

          {isOrderPage && onCartClick && (
            <button
              onClick={onCartClick}
              className="client-header-cart"
              aria-label="Keranjang belanja"
            >
              <svg className="client-header-cart-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
              {cartCount > 0 && (
                <span className="client-header-cart-badge">
                  {cartCount > 9 ? '9+' : cartCount}
                </span>
              )}
            </button>
          )}
          <ThemeToggle variant="header" />
        </div>
      </div>
    </header>
  )
}